import { Button } from "@mui/material";
import React, { useState } from "react";
import PopUps from "./PopUps";
import EvaluationAcknowledgmentForm from "./EvaluationAcknowledgmentForm";

const EvaluationActionPopUp = ({ data }) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const componetProps = {
        row: data,
    };

    return (
        <div>
            <Button variant="contained" onClick={handleClick}>
                View
            </Button>

            <PopUps
                open={open}
                setOpen={setOpen}
                componentProps={componetProps}
                component={EvaluationAcknowledgmentForm}
            />
        </div>
    );
};

export default EvaluationActionPopUp;
